import { z } from '@qred/components-library';
import { turnoverSchema } from '~/components/shared/TurnoverSelect/TurnoverSelect';
import { LoanPurposes } from '~/enums';

// Validation functions for better readability and maintainability
const validateLoanPurposeReason = (data: {
  purposeOfLoan: LoanPurposes;
  reason: string;
}) => {
  if (data.purposeOfLoan === LoanPurposes.Other) {
    return data.reason.trim().length > 0;
  }
  return true;
};

const loanPurposeSchema = z
  .object({
    purposeOfLoan: z.nativeEnum(LoanPurposes, {
      required_error: 'ValidationErrors.Required',
    }),
    reason: z.string().max(190, {
      message: 'ValidationErrors.MaxLength190',
    }),
  })
  .refine(validateLoanPurposeReason, {
    message: 'ValidationErrors.Required',
    path: ['reason'],
  });

const companyDetailsSchema = z
  .object({
    companyName: z.string().min(1, { message: 'ValidationErrors.Required' }),
    companyNumber: z.string().min(1, { message: 'ValidationErrors.Required' }),
    companyType: z.string().optional(),
  })
  .optional();

export const startApplicationSchema = z
  .object({
    companyIsNew: z.boolean(),
    clientId: z.string().optional(),
    companyDetails: companyDetailsSchema,
    loanPurpose: loanPurposeSchema,
    ...turnoverSchema.shape,
    incomeReceivedInForeignCurrencies: z.boolean({
      required_error: 'ValidationErrors.Required',
    }),
  })
  .superRefine((data, ctx) => {
    // If neither a client is selected nor it's a new company, error on clientId
    if (!data.clientId && !data.companyIsNew) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'ValidationErrors.Required',
        path: ['clientId'],
      });
    }

    // If it's a new company and companyDetails is missing, error on companyDetails
    if (data.companyIsNew && !data.companyDetails) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'ValidationErrors.Required',
        path: ['companyDetails'],
      });
    }
  });

export type StartApplicationForm = z.infer<typeof startApplicationSchema>;
